import React from 'react'

const TrainingSchool = () => {
  return (
    <div className="m-4 sm:m-8 lg:m-16">
      <div className="flex flex-col md:flex-row mx-auto space-y-8 md:space-y-0 md:space-x-16">
        <img
          src="assets/dog6.jpg"
          alt="Dog"
          className="w-full sm:w-60 h-60 object-cover rounded-md mx-auto md:mx-0"
        />
        <ul className="mx-8 sm:mx-16">
          <h1 className="text-2xl sm:text-xl font-semibold">What We Offer?</h1>
          <li className="text-lg sm:text-xl my-2 mt-4">1. We provide your puppy knowledge such as sit, stay</li>
          <li className="text-lg sm:text-xl my-2">2. Socialising with other dogs</li>
          <li className="text-lg sm:text-xl my-2">3. Toilet Training</li>
          <li className="text-lg sm:text-xl my-2">4. How to walk on leash training</li>
        </ul>
      </div>

      <div className="flex flex-col md:flex-row mx-8 md:mx-16 my-8 space-y-8 md:space-y-0 md:space-x-32">
        <div className="flex flex-col">
          <h1 className="text-2xl sm:text-xl font-semibold my-2">Requirements for Puppies Training</h1>
          <p className="text-lg sm:text-xl">1. Puppies should be between 4 months to 9 months of age.</p>
          <p className="text-lg sm:text-xl">2. Puppies must be fully vaccinated.</p>
        </div>

        <div className="flex flex-col">
          <h1 className="text-2xl sm:text-xl font-semibold my-2">The Required Vaccines are:</h1>
          <ul className="text-lg sm:text-xl">
            <li>1. DHPPI</li>
            <li>2. Coronavirus</li>
            <li>3. Rabies</li>
          </ul>
        </div>
      </div>

      <div className="mx-8 sm:mx-16 my-8 shadow-lg p-8 text-center bg-white rounded-md">
        <h1 className="text-3xl sm:text-4xl font-bold">Book Your Session Today!</h1>
        <div className="flex flex-col items-center mt-8">
          <a
            href="tel:9354623839"
            className="font-semibold text-xl flex items-center justify-center my-4 text-blue-600"
          >
            <img
              src="https://cdn-icons-png.flaticon.com/512/9968/9968669.png"
              alt="Call"
              className="h-16 w-16 mx-4"
            />
            +91 9354623839
          </a>
        </div>
      </div>
    </div>
  )
}

export default TrainingSchool
